import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';

import { Exposes } from './pages/Exposes';
import { ExposeDetail } from './pages/ExposeDetail';
import { Ramadan } from './pages/Ramadan';
import { RamadanDetail } from './pages/RamadanDetail';
import { Events } from './pages/Events';
import { EventDetail } from './pages/EventDetail';
import { Bibliotheque } from './pages/Bibliotheque';
import { MaraboutDetail } from './pages/MaraboutDetail';
import { CoranDetail } from './pages/CoranDetail';
import { Mediatheque } from './pages/Mediatheque';
import { Profile } from './pages/Profile';
import { Galerie } from './pages/Galerie';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { Daara } from './pages/Daara';
import { DaaraDetail } from './pages/DaaraDetail';
import { AdminDashboard } from './pages/admin/Dashboard';
import { AdminExposes } from './pages/admin/AdminExposes';
import { AdminRamadan } from './pages/admin/AdminRamadan';
import { AdminEvents } from './pages/admin/AdminEvents';
import { AdminBibliotheque } from './pages/admin/AdminBibliotheque';
import { AdminMediatheque } from './pages/admin/AdminMediatheque';
import { AdminUsers } from './pages/admin/AdminUsers';
import { AdminGalerie } from './pages/admin/AdminGalerie';
import { AdminNotifications } from './pages/admin/AdminNotifications';
import { AdminAnalytics } from './pages/admin/AdminAnalytics';
import { AdminAdvertisements } from './pages/admin/AdminAdvertisements';
import { AdminContact } from './pages/admin/AdminContact';
import { AdminDaara } from './pages/admin/AdminDaara';
import { AdminKnowledgeBase } from './pages/admin/AdminKnowledgeBase';
import { AdminChatHistory } from './pages/admin/AdminChatHistory';
import { AdminEngagedMembers } from './pages/admin/AdminEngagedMembers';
import { AdminPublicQuestions } from './pages/admin/AdminPublicQuestions';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/exposes" element={<Layout><Exposes /></Layout>} />
            <Route path="/exposes/:id" element={<Layout><ExposeDetail /></Layout>} />
            <Route path="/ramadan" element={<Layout><Ramadan /></Layout>} />
            <Route path="/ramadan/:id" element={<Layout><RamadanDetail /></Layout>} />
            <Route path="/events" element={<Layout><Events /></Layout>} />
            <Route path="/events/:id" element={<Layout><EventDetail /></Layout>} />
            <Route path="/bibliotheque" element={<Layout><Bibliotheque /></Layout>} />
            <Route path="/bibliotheque/marabouts/:id" element={<Layout><MaraboutDetail /></Layout>} />
            <Route path="/bibliotheque/coran/:id" element={<Layout><CoranDetail /></Layout>} />
            <Route path="/mediatheque" element={<Layout><Mediatheque /></Layout>} />
            <Route path="/galerie" element={<Layout><Galerie /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/faq" element={<Layout><FAQ /></Layout>} />
            <Route path="/daara" element={<Layout><Daara /></Layout>} />
            <Route path="/daara/:id" element={<Layout><DaaraDetail /></Layout>} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Layout><Profile /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/exposes"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminExposes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/ramadan"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminRamadan />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/events"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminEvents />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/galerie"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminGalerie />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/bibliotheque"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminBibliotheque />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/mediatheque"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminMediatheque />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/notifications"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminNotifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/analytics"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminAnalytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/advertisements"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminAdvertisements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/contact"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminContact />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/daara"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDaara />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/knowledge-base"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminKnowledgeBase />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/chat-history"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminChatHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/engaged-members"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminEngagedMembers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/public-questions"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminPublicQuestions />
                </ProtectedRoute>
              }
            />
          </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
